export default __webpack_public_path__ + "static/media/pending_icon.a24ea738.svg";